import * as stylex from "@stylexjs/stylex";
import { colors, fonts, fontSizes } from "@softmax/design-system/tokens.stylex";

import { renderNativeLink, type BrowseLinkRenderer } from "./browse-link";

export function BrowseTileContinuation({
  href,
  name,
  renderLink = renderNativeLink,
}: {
  readonly href: string;
  readonly name: string;
  readonly renderLink?: BrowseLinkRenderer;
}) {
  return renderLink({
    href,
    "aria-label": `Continue playing ${name}`,
    ...stylex.props(styles.continueLink),
    children: "Continue playing →",
  });
}

const styles = stylex.create({
  continueLink: {
    color: colors.foreground,
    fontFamily: fonts.sans,
    fontSize: fontSizes.body,
  },
});
